import truncate from 'lodash.truncate'

export const truncateString = (string, length) => {
  return truncate(string, { length: length, separator: '' })
}
